import { render, staticRenderFns } from "./CustomFieldsAddressModal.vue?vue&type=template&id=5d2549e5&"
import script from "./CustomFieldsAddressModal.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports